import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-up-big",
  "use": "icon-chevron-up-big-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-chevron-up-big\"><path d=\"m8 4.6 5.1 5.1-.7.7L8 6l-4.4 4.4-.7-.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol